import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class PronunciationPopup extends Vue {
  @Prop({default: () => []})
  changeWordList: Array<any>
  @Prop({default: () => []})
  changeNumberList: Array<any>
  @Prop({default: () => []})
  diffList: Array<any>
  @Prop({default: ''})
  oldSubtitlesText: string
  @Prop({default: false})
  isChangeText: boolean
  show = false
  isWordChecked = true
  isNumChecked = true
  isEditChecked = true
  // 是否超出最大限制
  isMax = false
  checkedIcon = this.$publicPath + 'images/video_editor/checked_1713866287568_icon.png'
  unCheckedIcon = this.$publicPath +  'images/video_editor/unchecked_icon.png'

  @Watch('show')
  listenShow(val) {
    if (val) {
      if (this.diffList.length) {
        const addList = this.diffList.filter(item => item.highlight === 'add')
        const rmList = this.diffList.filter(item => item.highlight === 'remove')
        const rpList = this.diffList.filter(item => item.highlight === 'replaced')
        console.log('rmList', rmList)
        let count = 0
        this.diffList.forEach(item => {
          if (item.highlight === 'add' || item.highlight === 'replaced') {
            count += item.value.length
          } else if (item.highlight === 'remove') {
            count += item.removeVal.length
          }
        })
        if ((addList.length + rmList.length + rpList.length) > 2 || count >= 5) {
          this.isMax = true
          this.isEditChecked = true
        } else {
          this.isMax = false
        }
      } else {
        this.isMax = false
      }
      console.log('listenShow', this.diffList)
    }
  }

  selectEdit() {
    if (this.isMax) return
    this.isEditChecked = !this.isEditChecked
  }
  selectWord() {
    this.isWordChecked = !this.isWordChecked
  }
  selectNum() {
    this.isNumChecked = !this.isNumChecked
  }
  closePopup() {
    this.show = false
  }
  confrimEdit() {
    this.show = false
    this.$emit('confirm-edit' , {
      isEditChecked: this.isEditChecked,
      isWordChecked: this.isWordChecked,
      isNumChecked: this.isNumChecked,
      isForce: this.isMax
    })
  }
  cancelEdit() {
    this.show = false
    this.$emit('cancel-edit')
  }
}